import { useEffect } from "react";

import { useDispatch } from "react-redux";

import { setAuthenticated, setInitialized } from "features/auth/authSlice";

import { clearUser, setUser } from "features/user/userSlice";

import authService from "./authService";

import tokenService from "./tokenService";

export default function AuthInitializer({ children }) {
    const dispatch = useDispatch();

    const initialize = async () => {
        const token = tokenService.getToken();

        if (!token) {
            dispatch(setInitialized(true));

            return;
        }

        try {
            const response = await authService.me();

            dispatch(
                setUser({
                    profile: response?.currentUser,
                    username: response.username,

                    roles: response.roles,

                    permissions: response.permissions
                })
            );

            dispatch(setAuthenticated(true));
        } catch (error) {
            console.log("error Authentication", error);
            tokenService.clear();

            dispatch(clearUser());

            dispatch(setAuthenticated(false));
        } finally {
            dispatch(setInitialized(true));
        }
    };

    useEffect(() => {
        initialize();
    }, []);

    return children;
}
